import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user:null,
        configuration:null
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload;
        },
        setConfiguration(state, payload) {
            state.configuration = payload;
        }
    },
    actions: {
        setUser({commit}, user) {
            localStorage.setItem('user', JSON.stringify(user));
            commit('setUser', user);
        },
        setConfiguration({commit}, configuration) {
            localStorage.setItem('configuration', JSON.stringify(configuration));
            commit('setConfiguration', configuration);
        }
    },
    getters: {
        isAuthenticated: (state) => {
            return (state.user);
        },
    }
})
